import { useAppSelector } from '~/store/hooks'
import * as panelsLibrary from '../Panels'

export default function PanelManager(props) {
  const panel = useAppSelector(state => state.panel)
  const visiblePanels = Object.keys(panel).reduce((panels, side) => {
    const visibleKey = panel[side].visiblePanel
    if (panel[side][visibleKey]) panels.push(panel[side][visibleKey])
    return panels
  }, [])
  const panels = visiblePanels.map(panel => {
    const Component = panelsLibrary[panel.component]
    if (props.forceAlignment) {
      return <Component {...props} alignment={props.forceAlignment} key={panel.component} />
    }
    return <Component {...props} key={panel.component} />
  })
  return panels
}
